import { useNavigate } from 'react-router-dom';

const FOOTER_LINKS = [
  { label: '이용 약관', path: '/terms' },
  { label: '개인정보 처리방침', path: '/privacy' },
  { label: '쿠키 정책', path: '/privacy' },
  { label: '고객센터', path: '/support' },
];

export default function LandingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        {FOOTER_LINKS.map((item) => (
          <button
            key={item.label}
            type="button"
            className="landing-footer__link"
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </button>
        ))}
        <span className="landing-footer__copyright">
          ⓒ GrowFit + BCT ONE Inc.. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
}
